// Utility functions for managing first-time modal state

/**
 * Reset first-time modal state for all routes
 */
export const resetAllFirstTimeStates = () => {
  const routeTypes = [
    'invoice_create',
    'invoice_calculate', 
    'template_create',
    'template_edit',
    'claim_create',
    'tracking'
  ];
  
  routeTypes.forEach(type => {
    localStorage.removeItem(`firstTime_${type}`);
  });
  
  console.log('All first-time modal states have been reset');
};

/**
 * Reset first-time modal state for a specific route type
 * @param {string} routeType - The route type to reset
 */
export const resetFirstTimeState = (routeType) => {
  localStorage.removeItem(`firstTime_${routeType}`);
  console.log(`First-time modal state for ${routeType} has been reset`);
};

/**
 * Set first-time modal state as seen for a specific route type
 * @param {string} routeType - The route type to mark as seen
 */
export const setFirstTimeSeen = (routeType) => {
  localStorage.setItem(`firstTime_${routeType}`, 'true');
  console.log(`First-time modal state for ${routeType} has been marked as seen`);
};

/**
 * Check if first-time modal has been seen for a specific route type
 * @param {string} routeType - The route type to check
 * @returns {boolean} - True if modal has been seen, false otherwise
 */
export const hasSeenFirstTimeModal = (routeType) => {
  return localStorage.getItem(`firstTime_${routeType}`) === 'true';
};

/**
 * Get all first-time modal states
 * @returns {Object} - Object with route types as keys and boolean values
 */
export const getAllFirstTimeStates = () => {
  const routeTypes = [
    'invoice_create',
    'invoice_calculate', 
    'template_create',
    'template_edit',
    'claim_create',
    'tracking'
  ];
  
  const states = {};
  routeTypes.forEach(type => {
    states[type] = hasSeenFirstTimeModal(type);
  });
  
  return states;
};

// For development/testing purposes - expose to window object
if (process.env.NODE_ENV === 'development') {
  window.firstTimeModalUtils = {
    resetAllFirstTimeStates,
    resetFirstTimeState,
    setFirstTimeSeen,
    hasSeenFirstTimeModal,
    getAllFirstTimeStates
  };
} 